export default __webpack_public_path__ + "static/media/closet2-1440w.19c2bc95.webp";